import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import { LoyaltyApi } from "@jti/rest-api";
import { ConditionalView } from "@jti/rip";
import { RibbonBadge } from "@jti/ui/components/RibbonBadge";
import { useLoyalty } from "@jti/ui/hooks/useLoyalty";
import LoyaltyLogo from "@jti/ui/icons/loyalty_logo.svg";
import { useConfig } from "@jti/ui/providers/useConfig";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { TitleBorderContainer } from "@jti/ui-library";
import LimitedLogo from "./limitedLogo.svg";
import setLimitedRewardTimerContent from "./setLimitedRewardTimerContent";
import "./style.scss";
const { sanitize } = dompurify;
export const ProductLoyaltyBlock = ({ sku, marginBottom, selectedQuantity }) => {
    const { __: translate } = useTranslations();
    const config = useConfig();
    const isLoyaltyActive = useLoyalty();
    const [isLoaded, setLoaded] = useState(false);
    const [timeLimited, setTimeLimited] = useState(0);
    const [points, setPoints] = useState(0);
    const isTimeLimited = timeLimited > 0;
    const className = classNames("loyalty-reward-block", {
        "loyalty-reward-block--limitedRewardHolder": isTimeLimited,
    });
    const hours = translate("product.info.hours");
    const minutes = translate("product.info.minutes");
    const dayssingular = translate("product.info.daysSingular");
    const weekssingular = translate("product.info.weeksSingular");
    const daysplural = translate("product.info.daysPlural");
    const weeksplural = translate("product.info.weeksPlural");
    useEffect(() => {
        const productQuantity = selectedQuantity ?? 1;
        if (isLoyaltyActive) {
            const user = window.localStorage.getItem("user") ? JSON.parse(window.localStorage.getItem("user")) : null;
            LoyaltyApi.init()
                .getProductPoints(sku, productQuantity, user?.uuid, user?.ciam_token)
                .then((response) => {
                setPoints(response.points);
                if (response.time_limited) {
                    setTimeLimited(new Date(response.time_to).getTime());
                }
            })
                .finally(() => {
                setLoaded(true);
            });
        }
        else {
            setLoaded(true);
        }
    }, [isLoyaltyActive, selectedQuantity, sku]);
    if ((isLoaded && points <= 0) || !isLoyaltyActive) {
        return _jsx(React.Fragment, {});
    }
    return (_jsx("div", { className: className, children: _jsxs(TitleBorderContainer, { title: translate("product.info.reward"), marginBottom: marginBottom, isLoading: !isLoaded, children: [_jsx(ConditionalView, { condition: isTimeLimited, children: _jsx("span", { className: "loyalty-reward-block__circle ", children: _jsx("span", { children: translate("product.info.multiplier") }) }) }), isTimeLimited && (_jsx("h3", { className: "aem-productDetails__rowContainer-title", children: _jsx(ConditionalView, { condition: isTimeLimited, children: _jsx("span", { className: "subtitle", children: translate("product.info.limitedOffer") }) }) })), _jsx("div", { className: "loyalty-reward-block__loyaltyPointsLoading", children: _jsxs("div", { className: "loyalty-reward-block__reward", children: [_jsx("div", { className: "loyalty-reward-block__reward-logo-container", children: _jsx(LoyaltyLogo, {}) }), _jsxs("div", { className: "loyalty-reward-block__reward-content", "data-testid": "product-points", children: [_jsx(ConditionalView, { condition: isTimeLimited, children: _jsx("div", { className: "loyalty-reward-block__timer-container", children: _jsx(RibbonBadge, { text: setLimitedRewardTimerContent(timeLimited, hours, minutes, dayssingular, daysplural, weekssingular, weeksplural), icon: LimitedLogo, className: "loyalty-reward-block__timerr" }) }) }), _jsx(ConditionalView, { condition: !isTimeLimited, children: _jsx("span", { className: "aem-productDetails__stockText loyalty-reward-block__reward ", dangerouslySetInnerHTML: {
                                                __html: sanitize(translate("product.info.collectPoints", [points])),
                                            } }) }), _jsx(ConditionalView, { condition: isTimeLimited, children: _jsx("span", { className: "aem-productDetails__stockText loyalty-reward-block--limitedReward ", dangerouslySetInnerHTML: {
                                                __html: sanitize(translate("product.info.collectLimitedPoints", [points])),
                                            } }) }), _jsx(ConditionalView, { condition: !isTimeLimited, children: _jsx("a", { href: config.LOYALTY_KNOW_MORE_URL, className: "aem-productDetails__stockText aem-productDetails__stockText--link", children: translate("product.info.knowMore") }) })] })] }) })] }) }));
};
//# sourceMappingURL=ProductLoyaltyBlock.js.map